import { Media, Texts, Title } from "../components/Object";
import { Scroll } from "../components/Animation";
import { Space } from "../components/Layout";
import { List, NavList } from "../components/Project/Merit";
import { Head, News } from "../components/Project";

const Point = () => {
  const args = {
    slug: "point",
    length: 4,
    addText: [
      [
        '信頼できる送り出し機関との連携で<br class="pc"/>優秀な人材を確保できます。',
        '送り出し機関とは、外国人技能実習制度の趣旨を理解し、日本の監理団体に対して技能実習の候補者を適切に募集・選抜・送り出すことができる機関のことです。<br><br>送り出し機関は、入国前の実習生候補者に対して日本語はもちろん、日本の法令・文化・道徳などを徹底的に教育することで、受け入れ後の実習もスムーズに進めることができます。',
      ],
      [
        '企業様と実習生が友好な関係性を築いた上で、<br class="pc"/>配属できるようサポートをいたします',
        '技能実習生の受け入れにあたり、国民性・異文化による考え方の違い、意思疎通の難しさなどの不安があるかと思います。当組合では面接後採用が決まり配属までの間にオンラインなどで面談を行い、企業様と実習生の双方が安心して技能実習を実施できるよう努めて参ります。',
      ],
      [
        '実習生の配属後もメンタルケアを中心とした<br class="pc"/>フォローアップ体制を構築します',
        'ヒアリングによる問題解決や心身両面のケアなど、母国を離れて暮らす実習生のメンタルをサポートいたします。それぞれ個性も違えば、技能や言語を習得していくレベルも違います。安心して技能実習ができるように徹底したサポートを行っていきます。<br>技能実習生の心の悩みやストレスを解決するために、定期的に実習生同士で集まりバーベキューをしたりショッピングをしたりしてサポートをしていきます。',
      ],
      [
        '企業様の様々な問題を解決できるよう、<br class="pc"/>専門知識を持ったスタッフが対応いたします',
        '技能実習生の受け入れには、各種行政上の手続きが必要となります。当組合では専門知識を有したスタッフがこのような手続きを一括管理しております。<br>初めて技能実習生を受け入れる場合には受け入れ要件から在留期間中の手続きまで、分かりやすく丁寧にご説明させていただきます。<br>また、技能実習生の病気や怪我などの不測の事態や何らかの問題が発生した際にもすぐに対応させていただきます。',
      ],
    ],
  };
  return (
    <>
      <Head slug="page-point"></Head>
      <Space size={['80px', '64px']} />
      <List {...args} />

      <Space size={['120px 0 0', '80px 0 0']}>
        <NavList />
      </Space>
    
      <Space size={['120px 0 15px', '80px 0 12px']}>
        <News />
      </Space>
    </>
  );
};
export default Point;